/**
 * Whether the end-of-conversation wrap-up should hard-redirect to the Genie's
 * published help page instead of rendering the wrap-up panel. Mirrors
 * LiveAgentPage.tsx's render-time `Navigate` short-circuit exactly: configured
 * redirects retain priority, and any active save or open follow-up must finish
 * first so the visitor isn't yanked away mid-action.
 */
export function shouldRedirectToHelpPage(args: {
  showWrapUp: boolean;
  helpPageUrl: string | null;
  agentRedirectUrl?: string | null;
  voiceConnected: boolean;
  voiceIsConnecting: boolean;
  isSavingImages: boolean;
  pendingImageUploads: number;
  failedImageUploads: number;
  followUpOpen: boolean;
  followUpIsPending: boolean;
}): boolean {
  return (
    args.showWrapUp &&
    !!args.helpPageUrl &&
    !args.agentRedirectUrl &&
    !args.voiceConnected &&
    !args.voiceIsConnecting &&
    !args.isSavingImages &&
    args.pendingImageUploads === 0 &&
    args.failedImageUploads === 0 &&
    !args.followUpOpen &&
    !args.followUpIsPending
  );
}
